import {
  FC,
  PropsWithChildren,
} from 'react'
import { motion } from 'motion/react'

export enum SlideInDirection {
  left = 'left',
  right = 'right',
}

const SlideInMotion:FC<
  PropsWithChildren<{
    direction:SlideInDirection,
    delay?:number,
  }>
> = ({
  direction,
  delay = 0,
  children,
}) => {
  const { left } = SlideInDirection

  return (
    <motion.div
      initial={{
        x: direction === left
          ? -100
          : 100,
        opacity: 0,
      }}
      animate={{
        x: 0,
        opacity: 1,
      }}
      transition={{
        duration: 0.5,
        ease: 'easeOut',
        delay,
      }}
    >
      {children}
    </motion.div>
  )
}

export default SlideInMotion
